import { createBrowserHistory } from "history";

export const LocationService = {
  History: createBrowserHistory(),
};
